import { APP_SECRET } from '../../constants/index';
export { default as checkProps } from './checkProps';
export { default as findByTestAttr } from './findByTestAttr';
var CryptoJS = require('crypto-js');

export const decryptPlainText = (cipherText, secret = null) => {
	const bytes = CryptoJS.AES.decrypt(cipherText, secret || APP_SECRET);
	const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
	return decryptedText;
};
